import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      padding: 60,
      [theme.fn.smallerThan('sm')]: {
        padding: 0,
      },
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 24,
      position: 'relative',
      padding: `0 0 24px 0`,
      [theme.fn.largerThan('sm')]: {
        padding: `0 80px`,
        backgroundImage:
          'linear-gradient(90deg, rgba(180, 214, 249, 0) 0%, rgba(180, 214, 249, 0.25) 50.5%, rgba(180, 214, 249, 0) 100%)',
      },
    },
    border: {
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
      [theme.fn.largerThan('sm')]: {
        position: 'relative',
        width: '100%',
        '&:before': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          height: 2,
          top: 1,
          backgroundImage:
            'linear-gradient(90deg, rgba(32, 202, 255, 0) 0%, #20CAFF 54.74%, rgba(32, 202, 255, 0) 110.59%)',
        },
        '&:after': {
          content: '""',
          height: 4,
          width: '100%',
          filter: 'blur(8px)',
          display: 'block',
          backgroundImage:
            'linear-gradient(90deg, rgba(32, 202, 255, 0) 0%, #20CAFF 54.74%, rgba(32, 202, 255, 0) 110.59%)',
        },
      },
    },
    ruleBoxTitle: {
      color: '#fff',
    },
    header: {
      textAlign: 'center',
      padding: '12px 24px',
      boxShadow: '2px 4px 8px 0px #031676',
      borderRadius: 24,
      position: 'relative',
      backgroundImage:
        'linear-gradient(162.6deg, #20CAFF -3.27%, #4297FC 113.89%)',
      '&:before': {
        content: '""',
        position: 'absolute',
        borderRadius: 'inherit',
        top: 1,
        left: 1,
        right: 1,
        bottom: 1,
        zIndex: 0,
        backgroundColor: '#0C2498',
      },
    },
    heading: {
      position: 'relative',
      // color: '#fff',
      fontSize: 32,
      lineHeight: '40px',
      textTransform: 'uppercase',
      color: '#fff',
      backgroundImage:
        'linear-gradient(350.43deg, #FFE16B -30.23%, #FFFFFF 90.17%)',
      backgroundClip: 'text',
      '-webkit-text-fill-color': 'transparent',
      textShadow: '1px 2px 4px 0px #000622',
    },
    listing: {
      display: 'flex',
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
        gap: 16,
      },
      [theme.fn.largerThan('sm')]: {
        gap: 80,
      },
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      position: 'relative',
      color: '#fff',
      p: {
        margin: '10px 0',
      },
      [theme.fn.smallerThan('sm')]: {
        paddingLeft: 24,
        '&:before': {
          content: '""',
          position: 'absolute',
          top: 18,
          left: 0,
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundImage:
            'linear-gradient(139.59deg, #FFE16B 2.87%, #FFBA0F 58.46%, #FB8908 89.05%)',
        },
      },
      [theme.fn.largerThan('sm')]: {
        '&:before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          transform: 'translate(0, -50%)',
          left: -40,
          height: '50%',
          maxHeight: 80,
          width: 1,
          background: theme.colors.neutral[1],
        },
        '&:first-child': {
          '&:before': {
            content: 'none',
          },
        },
      },
    },
    bannerWrapper: {
      [theme.fn.smallerThan('sm')]: {
        margin: '0 -10px 0 -16px',
      },
      [theme.fn.largerThan('sm')]: {
        display: 'none',
      },
    },
    banner: {
      display: 'block',
    },
  }
})
